setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'button.bss-checkout', handleButtonClick);
}, 500)